// The name to show for a signed-in account.
//
// `users/{uid}.name` is the account's name. Firebase Auth's `displayName` is a
// fallback only: this app never sets it, so only accounts made by the legacy
// app or by Google sign-in have one, and code reading it alone showed most
// users as their email prefix or a generic "Venue Manager". `useUser` names an
// account with no name "You", a placeholder rather than a name.

export function accountName(
  name: string | null | undefined,
  displayName: string | null | undefined
): string {
  const own = name?.trim();
  if (own && own !== "You") return own;
  return displayName?.trim() || "";
}
